var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 9,
    viewBox: "0 0 12.8 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bababa;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.619,4.809a.454.454,0,0,0-.645.639l3.271,3.271H.452A.449.449,0,0,0,0,9.171a.454.454,0,0,0,.452.458H11.245L7.974,12.894a.463.463,0,0,0,0,.645.452.452,0,0,0,.645,0l4.045-4.045a.444.444,0,0,0,0-.639Z",
    transform: "translate(0 -4.674)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.def6022cf67e2ecf831c23aae16f71da.svg";
export { ForwardRef as ReactComponent };